import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { theme } from "@sequentech/ui-essentials";
import { useTranslation } from "react-i18next";
import "./services/i18n";
import "./index.css";
import { SettingsWrapper } from "@/providers/SettingsContextProvider";
import { CustomCssContextProvider } from "@/providers/CustomCssContextProvider";
import { ResultsManifestContextProvider } from "@/providers/ResultsManifestContextProvider";
import { ResultsAuthContextProvider } from "@/providers/ResultsAuthContextProvider";
import { App } from "@/App";
import { ResultsRoute } from "@/routes/ResultsRoute";
import { StateMessage } from "@/components/StateMessage";
var UnexpectedResultsError = function () {
    var t = useTranslation().t;
    return (_jsx(StateMessage, { className: "seq-results-state-message--unexpected-error", title: t("resultsPortal.state.unexpectedErrorTitle"), message: t("resultsPortal.state.loadErrorMessage") }));
};
var ResultsNotPublished = function () {
    var t = useTranslation().t;
    return (_jsx(StateMessage, { className: "seq-results-state-message--not-published-route", title: t("resultsPortal.state.notPublishedTitle"), message: t("resultsPortal.state.notPublishedMessage") }));
};
var router = createBrowserRouter([
    {
        path: "/",
        element: _jsx(App, {}),
        errorElement: _jsx(UnexpectedResultsError, {}),
        children: [
            {
                path: ":eeId",
                element: _jsx(ResultsRoute, {}),
            },
            {
                path: ":eeId/elections/:electionId",
                element: _jsx(ResultsRoute, {}),
            },
            {
                path: "*",
                element: _jsx(ResultsNotPublished, {}),
            },
        ],
    },
], { basename: "/" });
ReactDOM.createRoot(document.getElementById("root")).render(_jsx(React.StrictMode, { children: _jsx(SettingsWrapper, { children: _jsx(CustomCssContextProvider, { children: _jsx(ResultsManifestContextProvider, { children: _jsx(ResultsAuthContextProvider, { children: _jsx(ThemeProvider, { theme: theme, children: _jsx(RouterProvider, { router: router }) }) }) }) }) }) }));
